module.exports = __webpack_public_path__ + "8b3b8dde0dbffa8b639cc9cb5d837230.png";